module.exports = __webpack_public_path__ + "img/bilge-pump-off.54b17766.svg";